import { OnboardingStart } from './onboarding-start';

export { OnboardingStart };
